import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "Terms of Use", to: "/terms", href: null },
  { label: "Privacy Policy", to: "/privacy", href: null },
  { label: "Contact", to: null, href: "mailto:hello@prooftous.app" },
  { label: "Instagram", to: null, href: "#join" },
  { label: "X", to: null, href: "#join" },
];

export const Footer = () => {
  return (
    <footer className="border-t border-[#1F1F1F] bg-black">
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-20">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#C9A94B]">
              Declare it. Prove it.
            </span>
            <div className="mt-3 font-display text-6xl uppercase leading-none tracking-tight text-white md:text-8xl">
              prooftous.app
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV_LINKS.map((l) => {
              const testid = `footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`;
              const cls =
                "font-mono text-[11px] uppercase tracking-[0.15em] text-[#8A8A8A] transition-colors hover:text-white";
              return l.to ? (
                <Link key={l.label} to={l.to} data-testid={testid} className={cls}>
                  {l.label}
                </Link>
              ) : (
                <a key={l.label} href={l.href} data-testid={testid} className={cls}>
                  {l.label}
                </a>
              );
            })}
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-[#1F1F1F] pt-6 md:flex-row md:items-center md:justify-between">
          <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#5A5A5A]">
            © {new Date().getFullYear()} proof — The accountability ledger
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#5A5A5A]">
            No excuses. Receipts only.
          </span>
        </div>
      </div>
    </footer>
  );
};
